import styled, { css, keyframes } from "styled-components";

const slideIn = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`;

const slideOut = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(100%); }
`;

export const Overlay = styled.div<{ $open: boolean }>`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 50;
  background: rgba(0, 0, 0, ${({ $open }) => ($open ? 0.4 : 0)});
  transition: background 0.3s ease;
  pointer-events: ${({ $open }) => ($open ? "auto" : "none")};
`;

export const Drawer = styled.div<{ $open: boolean }>`
  height: 100%;
  width: 100%;
  max-width: 450px;
  background: ${({ theme }) => theme.palette.cart.background};
  border-left: 1px solid ${({ theme }) => theme.palette.neutral.medium};
  display: flex;
  flex-direction: column;
  animation: ${({ $open }) =>
    $open
      ? css`${slideIn} 0.3s ease forwards`
      : css`${slideOut} 0.3s ease forwards`};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .5rem 1.25rem;
  border-bottom: 1px solid ${({ theme }) => theme.palette.neutral.medium};

  h4 {
    font-size: 1.125rem;
    font-weight: 600;
    color: ${({ theme }) => theme.palette.neutral.lightest};
  }
`;

export const IconButton = styled.button`
  all: unset;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.neutral.medium};
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.palette.neutral.lightest};
  }

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow-y: auto;
  padding: 0.5rem  1.25rem;
`;

export const Footer = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1.25rem;
`;

export const TotalBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3rem;
  padding: 0 0.75rem;
  background: ${({ theme }) => theme.palette.neutral.dark};
  border-radius: 0.75rem;

  p {
    font-size: 0.875rem;
    color: ${({ theme }) => theme.palette.neutral.medium};
  }

  span {
    font-weight: 600;
    color: ${({ theme }) => theme.palette.neutral.lightest};
  }
`;

export const CheckoutButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  border-radius: 0.75rem;
  background: ${({ theme }) => theme.palette.button.primary.background};
  color: ${({ theme }) => theme.palette.button.primary.text};
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.palette.primary.light};
  }
`;
